/**
 * RCM — Retail CIF Management module entry.
 * Search-first FSR landing + record-page with 5 tabs (Details / Products /
 * Documents / Tasks / History) per Bible §7.2.
 */
import './styles/rcm.css';
import { RcmRoutes } from './routes';

export default function RCM(): JSX.Element {
  return <RcmRoutes />;
}
